import { FormSetting } from '@/form-settings/form-setting';
import { DateControl } from '@components/dynamic-form/date-control';
import { ControlType } from '@components/dynamic-form/control-type';

export class MSCopyRowFormSetting extends FormSetting {
  protected static classToCall: string;
  private static rows: any[] = [];

  public static setClassToCall(classes: string) {
    this.classToCall = classes;
    return this;
  }

  public static getMeta(): Array<any> {
    this.rows = [];
    this.addRowCodiceMs();
    this.addRowMonthYearFrom();
    this.addRowMonthYearTo();
    return [
      {
        rows: this.rows,
        order: 1,
      },
    ];
  }

  private static addRowCodiceMs() {
    const inputsComponent = {} as DateControl;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'codiceMs';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Codice MS';
    inputsComponent.class = 'w-3/12';
    inputsComponent.disabled = true;
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowMonthYearFrom() {
    const inputsComponent = {} as DateControl;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'yearMonthFrom';
    inputsComponent.controlType = ControlType.monthYearDate;
    inputsComponent.label = 'Da mese/anno';
    inputsComponent.class = 'w-3/12';
    inputsComponent.maxDateToday = true;
    inputsComponent.required = true;
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowMonthYearTo() {
    const inputsComponent = {} as DateControl;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'yearMonthTo';
    inputsComponent.controlType = ControlType.monthYearDate;
    inputsComponent.label = 'A mese/anno';
    inputsComponent.class = 'w-3/12';
    inputsComponent.maxDateToday = true;
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }
}
